import { useCallback } from "react";
import domainList from "../domainConfig";
import { decodeJWT } from "aws-amplify/auth";
import AuthHelper from "../utils/AuthHelper";
import { clearAuthData } from "../redux/auth";
import { useDispatch } from "react-redux";

function useLogoutApps() {
    const dispatch = useDispatch();

    const logOutAppSession = useCallback(async () => {
        const decodedToken = decodeJWT(new AuthHelper().getIdToken() || "");
        const username = decodedToken.payload.phone_number?.toString().replace("+91", "");

        if (!username) return;
        for (const domain of domainList) {
            const appUrl = domain.sessionLogoutUrl;
            if (appUrl) await fetch(appUrl.replace('{{userId}}', username))

        }
    }, [])

    const logoutFormUi = useCallback(() => {
        for (const domain of domainList) {
            const appUrl = domain[process.env.REACT_APP_ENVIRONMENT as keyof typeof domain]
            const logoutUrl = domain.logoutPathname ? appUrl + domain.logoutPathname : null;
            if (logoutUrl) {
                const iFrame = document.createElement("iframe")
                iFrame.src = logoutUrl
                iFrame.style.display = 'none'
                document.body.appendChild(iFrame);
                setTimeout(() => {
                    document.body.removeChild(iFrame)
                }, 10_000)
            }
        }
    }, [])

    const logoutFormAllApps = useCallback(() => {
        dispatch(clearAuthData());
        logOutAppSession();
        logoutFormUi();
    }, [logoutFormUi, logOutAppSession, dispatch])

    return { logoutFormAllApps }

}

export default useLogoutApps;
